import React from 'react';

/**
 * Theme-aligned success dialog for Master Management flows (primary / secondary palette).
 */
const MasterSuccessModal = ({ open, message, onClose, title = 'Success' }) => {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="master-success-title"
        >
            <div className="w-full max-w-md overflow-hidden rounded-xl bg-white shadow-lg ring-2 ring-primary/20">
                <div className="bg-[#030253] px-6 py-2.5">
                    <h2 id="master-success-title" className="mb-0 text-center font-UbuntuBold !text-base !text-white">
                        {title}
                    </h2>
                </div>
                <div className="px-6 pb-4 pt-3 text-center font-UbuntuRegular">
                    <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-secondary/15">
                        <svg
                            className="h-6 w-6 text-secondary"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                        >
                            <path d="M20 6L9 17l-5-5" />
                        </svg>
                    </div>
                    <p className="mb-4 text-gray-800">{message}</p>
                    <button type="button" className="btn btn-primary min-w-32 rounded-full px-8 py-2 text-white" onClick={onClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MasterSuccessModal;
